import React, { useState, useCallback } from 'react';
import { Resizable } from 'react-resizable';
import 'react-resizable/css/styles.css';
import { ResizableTitleProps } from '../types';
import styles from './index.module.css';

const ResizableTitle: React.FC<ResizableTitleProps> = React.memo(props => {
  const { handleResize, width, style, ...restProps } = props;
  const [isResizing, setIsResizing] = useState(false);

  const onResizeStart = useCallback(() => setIsResizing(true), []);
  const onResizeStop = useCallback(() => setIsResizing(false), []);

  if (!width) return <th {...restProps} />;

  return (
    <Resizable
      width={width}
      height={0}
      onResize={handleResize!}
      onResizeStart={onResizeStart}
      onResizeStop={onResizeStop}
      draggableOpts={{ enableUserSelectHack: false }}
      handle={
        <span
          className="react-resizable-handle"
          onClick={e => e.stopPropagation()}
        />
      }
    >
      <th {...restProps} style={{ position: 'relative', ...style }}>
        {restProps.children}
        {isResizing && (
          <div
            className={styles.resizableTitleOverlay}
            onClick={e => e.stopPropagation()}
          />
        )}
      </th>
    </Resizable>
  );
});

export default ResizableTitle;
